/* Brand vote page. Every vote section registers itself with BNVote; the first
   vote asks for an email once (POST /join on the vote backend, plus a quiet
   Shopify customer signup so the voter lands on the presale list). After that
   the token in localStorage makes every vote one tap.
   Backend: Cloudflare Worker (see ~/bas-nanas-vote-backend). */

(function () {
  "use strict";
  var API = (window.BN_VOTE_API || "").replace(/\/+$/, "");
  var KEY = "bn_vote_token";
  var listeners = [];
  var results = null;
  var mine = { votes: {}, ranks: {}, battles: 0 };

  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function token() { return store(KEY); }

  function call(path, body) {
    var opts = body ? { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) } : {};
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { var e = new Error(data.error || "http_" + r.status); e.code = data.error; throw e; }
        return data;
      });
    });
  }

  function setResults(r) {
    if (!r || !r.polls) return;
    results = r;
    document.querySelectorAll("[data-bn-voters]").forEach(function (n) { n.textContent = r.voters.toLocaleString(); });
    listeners.forEach(function (fn) { try { fn(results, mine); } catch (e) {} });
  }
  function refresh() { return call("/results").then(setResults).catch(function () {}); }

  // ------------------------------------------------------------ email gate
  var modal, pending = [];
  function buildModal() {
    modal = document.createElement("dialog");
    modal.className = "bn-modal";
    modal.setAttribute("aria-labelledby", "bn-modal-title");
    modal.innerHTML =
      '<form class="bn-modal-card" novalidate>' +
      '<button class="bn-x" type="button" aria-label="Close">×</button>' +
      '<p class="bn-modal-kicker">One quick thing</p>' +
      '<h2 id="bn-modal-title">Add your email to lock in your votes.</h2>' +
      '<p class="bn-modal-sub">One email, one vote per poll, so the results stay fair. You also get first access to the presale.</p>' +
      '<label class="sr-only" for="bn-email">Email address</label>' +
      '<div class="bn-modal-row"><input id="bn-email" type="email" required autocomplete="email" placeholder="you@email.com">' +
      '<button class="btn btn-ink" type="submit">Count my vote</button></div>' +
      '<p class="bn-modal-err" role="alert" hidden></p>' +
      '<p class="bn-modal-fine">Free. One short update a week at most. Unsubscribe anytime.</p>' +
      "</form>";
    document.body.appendChild(modal);
    var form = modal.querySelector("form");
    var input = modal.querySelector("input");
    var err = modal.querySelector(".bn-modal-err");
    var btn = modal.querySelector("button[type=submit]");
    function close(ok) {
      if (modal.open) modal.close();
      var p = pending; pending = [];
      p.forEach(function (d) { ok ? d.resolve(token()) : d.reject(new Error("cancelled")); });
    }
    modal.querySelector(".bn-x").addEventListener("click", function () { close(false); });
    modal.addEventListener("cancel", function (e) { e.preventDefault(); close(false); });
    modal.addEventListener("click", function (e) { if (e.target === modal) close(false); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { err.textContent = "That email doesn't look right. Check it and try again."; err.hidden = false; return; }
      err.hidden = true; btn.disabled = true; btn.textContent = "Saving…";
      call("/join", { email: email, source: "vote page" }).then(function (d) {
        store(KEY, d.token);
        shopifySignup(email);
        btn.disabled = false; btn.textContent = "Count my vote";
        return loadMine().then(function () { close(true); });
      }).catch(function (e2) {
        btn.disabled = false; btn.textContent = "Count my vote";
        err.textContent = e2.code === "too_many" ? "Too many signups from this connection today. Try again tomorrow."
          : "We couldn't save that just now. Check your connection and try again.";
        err.hidden = false;
      });
    });
  }

  // Adds the voter to Shopify customers (presale list) without leaving the page.
  function shopifySignup(email) {
    try {
      var fd = new FormData();
      fd.append("form_type", "customer");
      fd.append("utf8", "✓");
      fd.append("contact[email]", email);
      fd.append("contact[tags]", "presale, vote page");
      fetch("/contact", { method: "POST", body: fd, credentials: "same-origin" }).catch(function () {});
    } catch (e) {}
  }

  function ensureVoter() {
    if (token()) return Promise.resolve(token());
    if (!modal) buildModal();
    return new Promise(function (resolve, reject) {
      pending.push({ resolve: resolve, reject: reject });
      if (!modal.open) { modal.showModal(); setTimeout(function () { modal.querySelector("input").focus(); }, 30); }
    });
  }

  function loadMine() {
    if (!token()) return Promise.resolve();
    return call("/me?token=" + token()).then(function (d) { mine = d; setResults(results); })
      .catch(function (e) { if (e.code === "unknown_voter") store(KEY, null); });
  }

  // Run a write; if the stored token went stale, ask for the email again once.
  function withVoter(fn) {
    return ensureVoter().then(function (t) {
      return fn(t).catch(function (e) {
        if (e.code !== "unknown_voter") throw e;
        store(KEY, null);
        return ensureVoter().then(fn);
      });
    });
  }

  window.BNVote = {
    onResults: function (fn) { listeners.push(fn); if (results) fn(results, mine); },
    mine: function () { return mine; },
    vote: function (poll, option, label) {
      return withVoter(function (t) { return call("/vote", { token: t, poll: poll, option: option, label: label }); })
        .then(function (r) { mine.votes[poll] = option; setResults(r); return r; });
    },
    battle: function (game, w, l) {
      return withVoter(function (t) { return call("/battle", { token: t, game: game, winner: w.id, loser: l.id, wlabel: w.label, llabel: l.label }); })
        .then(function () { mine.battles = (mine.battles || 0) + 1; });
    },
    rank: function (poll, items) {
      return withVoter(function (t) { return call("/rank", { token: t, poll: poll, items: items }); })
        .then(function (r) { mine.ranks[poll] = items.map(function (i) { return i.id; }); setResults(r); return r; });
    },
    refresh: refresh,
    hasVoter: function () { return !!token(); },
  };

  if (!API) { console.warn("BNVote: no vote API URL set in theme settings"); return; }
  Promise.all([refresh(), loadMine()]);
  setInterval(function () { if (!document.hidden) refresh(); }, 30000);
})();
